import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useWallet } from '../../context/WalletContext';
import { useAdminStatus } from '../../hooks/useAdminStatus';
import { shortenAddress } from '../../utils/format';
import { Spinner } from '../common/Loader';
import './Navbar.css';

export default function Navbar() {
  const { isConnected, account, connect, disconnect, connecting, isCorrectNetwork, switchNetwork, switching } = useWallet();
  const { isPrivileged, verified } = useAdminStatus();
  // ONLY show admin menu when the check has completed AND the wallet is verified owner/admin.
  const showAdmin = verified === true && isPrivileged === true;
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isLanding = location.pathname === '/';

  const go = (path) => {
    setMobileOpen(false);
    navigate(path);
  };

  const scrollTo = (id) => {
    setMobileOpen(false);
    if (isLanding) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#' + id);
    }
  };

  return (
    <nav className="navbar">
      <div className="container navbar-inner">
        <Link to="/" className="navbar-brand" onClick={() => setMobileOpen(false)}>
          <img src="/logos/xterra-icon.png" alt="X-Terra" />
          <span>X-TERRA <span style={{ color: 'var(--accent)' }}>MINING</span></span>
        </Link>

        <div className="navbar-links">
          {isLanding ? (
            <>
              <button className="navbar-link" onClick={() => scrollTo('about')}>About</button>
              <button className="navbar-link" onClick={() => scrollTo('features')}>Features</button>
              <button className="navbar-link" onClick={() => scrollTo('why')}>Why Us</button>
              <button className="navbar-link" onClick={() => scrollTo('security')}>Security</button>
            </>
          ) : (
            <>
              <button className={`navbar-link ${location.pathname === '/dashboard' ? 'active' : ''}`} onClick={() => go('/dashboard')}>Dashboard</button>
              <button className={`navbar-link ${location.pathname === '/invest' ? 'active' : ''}`} onClick={() => go('/invest')}>Purchase</button>
              <button className={`navbar-link ${location.pathname === '/team' ? 'active' : ''}`} onClick={() => go('/team')}>Team</button>
              <button className={`navbar-link ${location.pathname === '/withdraw' ? 'active' : ''}`} onClick={() => go('/withdraw')}>Withdraw</button>
              <button className={`navbar-link ${location.pathname === '/xt-token' ? 'active' : ''}`} onClick={() => go('/xt-token')}>XT Token</button>
              {showAdmin && (
                <button
                  className={`navbar-link ${location.pathname === '/admin' ? 'active' : ''}`}
                  onClick={() => go('/admin')}
                  style={{ color: 'var(--warning)' }}
                >
                  ⚙ Admin
                </button>
              )}
            </>
          )}
        </div>

        <div className="navbar-right">
          {isConnected ? (
            <>
              {!isCorrectNetwork && (
                <button className="btn btn-secondary btn-sm" onClick={switchNetwork} disabled={switching}>
                  {switching ? <Spinner /> : 'Switch Network'}
                </button>
              )}
              <div className="wallet-chip">
                <span className="dot" />
                <span>{shortenAddress(account)}</span>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={disconnect}>Disconnect</button>
            </>
          ) : (
            <button className="btn btn-primary" onClick={connect} disabled={connecting}>
              {connecting ? <><Spinner /> Connecting</> : 'Connect Wallet'}
            </button>
          )}

          <button className="mobile-toggle" onClick={() => setMobileOpen((o) => !o)} aria-label="Menu">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {mobileOpen ? (
                <path strokeLinecap="round" d="M6 6l12 12M18 6L6 18" />
              ) : (
                <path strokeLinecap="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      <div className={`mobile-menu ${mobileOpen ? 'open' : ''}`}>
        {isLanding ? (
          <>
            <button className="navbar-link" onClick={() => scrollTo('about')}>About</button>
            <button className="navbar-link" onClick={() => scrollTo('features')}>Features</button>
            <button className="navbar-link" onClick={() => scrollTo('why')}>Why Us</button>
            <button className="navbar-link" onClick={() => scrollTo('security')}>Security</button>
            <button className="navbar-link" onClick={() => go('/dashboard')}>Open App</button>
          </>
        ) : (
          <>
            <button className="navbar-link" onClick={() => go('/dashboard')}>Dashboard</button>
            <button className="navbar-link" onClick={() => go('/invest')}>Purchase</button>
            <button className="navbar-link" onClick={() => go('/team')}>Team</button>
            <button className="navbar-link" onClick={() => go('/withdraw')}>Withdraw</button>
            <button className="navbar-link" onClick={() => go('/xt-token')}>XT Token</button>
            {showAdmin && (
              <button className="navbar-link" onClick={() => go('/admin')} style={{ color: 'var(--warning)' }}>
                ⚙ Admin
              </button>
            )}
          </>
        )}
        {isConnected && (
          <div className="wallet-chip" style={{ display: 'inline-flex', marginTop: 8, alignSelf: 'flex-start' }}>
            <span className="dot" />
            <span>{shortenAddress(account)}</span>
          </div>
        )}
      </div>
    </nav>
  );
}
